export const useUser = () => {
  return {
    user: null,
    loading: false,
    isAdmin: false,
    isAuthenticated: false,
  };
};
